<template>
  <div class="work-view">
    <h1>{{ title }}</h1>
    <TheArticle
      :class="'is-scrollable'"
      :article="article"
      :back="true"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TheArticle from '@blocks/TheArticle'
import View from '@mixins/View'

export default {
  name: 'WorkView',
  mixins: [ View ],
  components: {
    TheArticle
  },
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice',
      title: 'page/getTitle',
      article: 'page/getArticle'
    })
  },
  created () {
    this.fetchGetWorkPage({
      name: this.projectId
    })
  },
  methods: {
    ...mapActions({
      fetchGetWorkPage: 'page/fetchGetWorkPage'
    })
  }
}
</script>

<style lang="scss">
.work-view{
  width: 100%;
  background-color: black;

  h1{
    @include hide-visually;
  }

  .article{
    align-items: center;
    &__back,
    &__content{
      @include media("large"){
        max-width: 80rem;
      }
    }
  }
}
</style>
